import React from 'react';
import styled from 'styled-components';
import { Spinner } from '../../spinner';
import { IBaseComponentProps } from '../../types';


interface ILoaderProps extends IBaseComponentProps<HTMLDivElement> {
    hidden?: boolean;
}

function LoaderBase({ className, elementRef, hidden }: ILoaderProps) {
    return hidden ? null : (
        <div className={className} ref={elementRef}>
            <Spinner spinnerType="indeterminate" size="small" />
        </div>
    );
}

export const Loader = styled(LoaderBase)`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 20;
`;
